import { DataGrid, type GridColDef } from '@mui/x-data-grid'
import type { ComponentProps } from 'react'
import type { LedgerItem, Maybe } from '../generated/graphql'
import { formatTimestamp } from '../utils/util'
import NoTableResults from './NoTableResults'

const columns = [
  {
    field: 'id',
    headerName: 'ID',
    width: 90,
  },
  {
    field: 'category',
    headerName: 'Category',
    type: 'string',
    width: 180,
  },
  {
    field: 'amount',
    headerName: 'Amount',
    width: 120,
    type: 'number',
    valueFormatter: (value: number | undefined) => {
      if (typeof value === 'number') {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        }).format(value / 100)
      }
      return value
    },
  },
  {
    field: 'referenceType',
    headerName: 'Reference Type',
    type: 'string',
    flex: 1,
  },
  {
    field: 'referenceId',
    headerName: 'Reference ID',
    type: 'string',
    width: 334,
  },
  { field: 'market', headerName: 'Market', type: 'string', flex: 1 },
  { field: 'note', headerName: 'Note', type: 'string', flex: 1 },
  {
    field: 'updatedAt',
    headerName: 'Updated',
    flex: 1,
    type: 'dateTime',
    valueFormatter: (value: string | Date) => formatTimestamp(value),
  },
  {
    field: 'createdAt',
    headerName: 'Created',
    flex: 1,
    type: 'dateTime',
    valueFormatter: (value: string | Date) => formatTimestamp(value),
  },
]

export default function TransactionGrid(props: {
  rows: Maybe<LedgerItem>[]
  loading: boolean
  apiRef: ComponentProps<typeof DataGrid>['apiRef']
}) {
  return (
    <DataGrid
      apiRef={props.apiRef}
      rows={props.rows}
      columns={columns as GridColDef[]}
      density="compact"
      loading={props.loading}
      initialState={{
        pagination: {
          paginationModel: { pageSize: 500, page: 0 },
        },
      }}
      pageSizeOptions={[50, 100, 250, 500]}
      sx={{ flex: 1 }}
      slots={{
        noRowsOverlay: () => <NoTableResults text="No ledger items found" />,
      }}
    />
  )
}
